import request from '@/config/axios'

/** 景区钱包管理 */
export const getScenicWalletPage = (params: any) =>
  request.get({ url: '/scenic/wallet/page', params })

export const adjustScenicWalletBalance = (userId: number, amountFen: number, remark?: string) =>
  request.put({ url: '/scenic/wallet/adjust-balance', params: { userId, amountFen, remark } })

export const getScenicWalletRechargePage = (params: any) =>
  request.get({ url: '/scenic/wallet/recharge/page', params })

/** 充值套餐 */
export const getScenicWalletPackagePage = (params: any) =>
  request.get({ url: '/scenic/wallet-package/page', params })

export const createScenicWalletPackage = (data: any) =>
  request.post({ url: '/scenic/wallet-package/create', data })

export const updateScenicWalletPackage = (data: any) =>
  request.put({ url: '/scenic/wallet-package/update', data })

export const deleteScenicWalletPackage = (id: number) =>
  request.delete({ url: '/scenic/wallet-package/delete', params: { id } })

export const updateScenicWalletPackageStatus = (id: number, status: number) =>
  request.put({ url: '/scenic/wallet-package/status', params: { id, status } })
